// extracted by mini-css-extract-plugin
export var avatarContainer = "_8n-0";
export var avatarTypingWave = "_8n-i";
export var gray = "_8n-f";
export var green = "_8n-c";
export var icon = "_8n-9";
export var image = "_8n-1";
export var lg = "_8n-6";
export var md = "_8n-5";
export var presenceDot = "_8n-b";
export var red = "_8n-d";
export var sm = "_8n-4";
export var status = "_8n-a";
export var typingDot = "_8n-h";
export var typingPill = "_8n-g";
export var xl = "_8n-7";
export var xs = "_8n-3";
export var xxl = "_8n-8";
export var xxs = "_8n-2";
export var yellow = "_8n-e";